import { useDecisionMakerResponsePageData } from '#src/app/pages/decisionMakerResponse/details/pageContext';
import { useProcessedImageUrl } from '#src/app/shared/hooks/image';

type Result = ModelHookResult<{
	photo?: {
		url: string;
		mobileUrl: string;
	};
}>;

export function useDecisionMakerResponseMedia(): Result {
	const {
		data: {
			decisionMakerResponse: { photo },
		},
	} = useDecisionMakerResponsePageData();

	const photoUrl = useProcessedImageUrl(photo?.petitionMedium);
	const photoMobileUrl = useProcessedImageUrl(photo?.petitionSmall);

	return {
		data: {
			photo:
				photoUrl && photoMobileUrl
					? {
							url: photoUrl,
							mobileUrl: photoMobileUrl,
						}
					: undefined,
		},
	};
}
